module.exports = __webpack_public_path__ + "img/bm.4c756b60.jpg";